// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.4.0",
    "short": "6d18f06",
    "branch": "Detached: 6d18f06ed281fb65e2bc12b91ec37da525472d8b",
    "date": "2026-8-22"
};
/* eslint:enable */
